import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/api';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface LicencaDesktopExclusaoProps {
    show: boolean;
    onHide: () => void;
    idLicencaDesktop: string;
    onExcluir: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function LicencaDesktopExclusao(props: LicencaDesktopExclusaoProps) {
    const [nome, setNome] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoLicencaDesktop, setCarregandoLicencaDesktop] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoLicencaDesktop(true);
            api.get(`/LicencaDesktop/${props.idLicencaDesktop}`)
                .then(response => {
                    setNome(response.data.nome);
                    setCarregandoLicencaDesktop(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoLicencaDesktop(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        api.delete(`/LicencaDesktop/${props.idLicencaDesktop}`, data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível excluir a licença desktop: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoLicencaDesktop
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir a licença ${nome}?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default LicencaDesktopExclusao;